import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'search-stats',
    templateUrl: './search.stats.component.html',
    styleUrls: ['./search.stats.component.css']
})
export class SearchStatsComponent implements OnInit {
    IsBusy: boolean = false;

    // VARIABLES
    startDate: Date;
    endDate: Date;

    constructor() { }

    ngOnInit() {
    }


}
